module.exports = __webpack_public_path__ + "media/images/mission-6094fb4e4e32f7711edacf5ff456139d.png";